import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLock, faArrowRight } from '@fortawesome/free-solid-svg-icons';

interface EnrollPromptModalProps {
  show: boolean;
  onHide: () => void;
  onEnroll: () => void;
  courseTitle?: string;
}

const EnrollPromptModal: React.FC<EnrollPromptModalProps> = ({ show, onHide, onEnroll, courseTitle }) => {
  return (
    <Modal 
      show={show} 
      onHide={onHide} 
      centered 
      className="enroll-prompt-modal"
      contentClassName="border-0 shadow-lg"
    >
      <Modal.Body className="text-center p-5">
        <div 
          className="mx-auto mb-4 d-flex align-items-center justify-content-center" 
          style={{ 
            width: '80px', 
            height: '80px', 
            backgroundColor: '#F9731615', 
            borderRadius: '50%',
            color: '#F97316',
            fontSize: '2rem'
          }}
        >
          <FontAwesomeIcon icon={faLock} />
        </div>
        
        <h3 className="fw-bold mb-3" style={{ color: '#0A192F' }}>Enroll to Access Brochure</h3>
        <p className="text-muted mb-4 px-3">
          Detailed brochures for <strong>{courseTitle || 'this course'}</strong> are reserved for enrolled students. 
          Please enroll to view the full curriculum, topics, and outcomes.
        </p>

        <div className="d-grid gap-2">
          <Button 
            variant="primary" 
            size="lg" 
            onClick={() => {
              onHide();
              onEnroll();
            }}
            style={{ 
              backgroundColor: '#F97316', 
              border: 'none', 
              borderRadius: '12px',
              fontWeight: 700,
              padding: '12px'
            }}
          >
            Enroll Now <FontAwesomeIcon icon={faArrowRight} className="ms-2" />
          </Button>
          <Button 
            variant="link" 
            className="text-muted mt-2 text-decoration-none fw-semibold"
            onClick={onHide}
          >
            Maybe Later
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default EnrollPromptModal;
